function isSteelMaterial(material) {
    return material['Type'] == 'AISC Steel';
}

function isEuropeanSteel(material) {
  return material['Type'] === 'European Steel'
}

function isWoodMaterial(material) {
    return material['Type'] == 'Visually Graded Lumber';
}

function openModalMaterialDialog() {
    $('#modal-material-selector-dialog').modal('show');
}

function initSteelTable() {
    var materials = steelMaterialJson;

    var str = "<table class='table'><thead>";
    str += '<tr>';
    str += '<th>Name</th>';
    str += '<th>Fy (ksi)</th>';
    str += '<th>Elastic Modulus (ksi)</th>';
    str += '</thead>';

    for( var m in materials ) {
        str += "<tr class='wsMaterial_" + m + "'>";
        str += '<td>' + materials[m].Name + '</td>';
        str += '<td>' + materials[m].Fy + '</td>';
        str += '<td>' + materials[m].E + '</td>';
    }
    str += '</table>';
    $('#steel-material-table').html(str);

    $('#steel-material-table tr').click(function (event) {
        var myClass = $(this).attr('class'),
            index = myClass.split(/wsMaterial_/)[1];
        $('#modal-material-selector-dialog').trigger( 'north-american-steel-material-selected', steelMaterialJson[index]);
        $(function () {
            $('#modal-material-selector-dialog').modal('toggle');
        });
    });
}

function initEuropeanSteelTable() {
    var materials = europeanSteelMaterialJson;

    var str = "<table class='table'><thead>";
    str += '<tr>';
    str += '<th>Name</th>';
    str += '<th>Fy (MPa)</th>';
    str += '<th>Elastic Modulus (GPa)</th>';
    str += '</thead>';

    for( var m in materials ) {
        str += "<tr class='wsMaterial_" + m + "'>";
        str += '<td>' + materials[m].Name + '</td>';
        str += '<td>' + materials[m].Fy + '</td>';
        str += '<td>' + materials[m].E + '</td>';
    }
    str += '</table>';
    $('#european-steel-material-table').html(str);

    $('#european-steel-material-table tr').click(function (event) {
        var myClass = $(this).attr('class'),
            index = myClass.split(/wsMaterial_/)[1];
        $('#modal-material-selector-dialog').trigger( 'european-steel-material-selected', europeanSteelMaterialJson[index]);
        $(function () {
            $('#modal-material-selector-dialog').modal('toggle');
        });
    });
}

function initASTMSteelTable() {
    var materials = astmSteelMaterialJson;

    var str = "<table class='table'><thead>";
    str += '<tr>';
    str += '<th>Name</th>';
    str += '<th>Fy (MPa)</th>';
    str += '<th>Elastic Modulus (GPa)</th>';
    str += '</thead>';

    for( var m in materials ) {
        str += "<tr class='wsMaterial_" + m + "'>";
        str += '<td>' + materials[m].Name + '</td>';
        str += '<td>' + materials[m].Fy + '</td>';
        str += '<td>' + materials[m].E + '</td>';
    }
    str += '</table>';
    $('#astm-steel-material-table').html(str);

    $('#astm-steel-material-table tr').click(function (event) {
        var myClass = $(this).attr('class'),
            index = myClass.split(/wsMaterial_/)[1];
        $('#modal-material-selector-dialog').trigger( 'astm-steel-material-selected', astmSteelMaterialJson[index]);
        $(function () {
            $('#modal-material-selector-dialog').modal('toggle');
        });
    });
}

function initAluminumTable() {
    var materials = aluminumMaterialJson;

    var str = "<table class='table'><thead>";
    str += '<tr>';
    str += '<th>Name</th>';
    str += '<th>Fy (MPa)</th>';
    str += '<th>Elastic Modulus (GPa)</th>';
    str += '</thead>';

    for( var m in materials ) {
        str += "<tr class='wsMaterial_" + m + "'>";
        str += '<td>' + materials[m].Name + '</td>';
        str += '<td>' + materials[m].Fy + '</td>';
        str += '<td>' + materials[m].E + '</td>';
    }
    str += '</table>';
    $('#aluminum-material-table').html(str);

    $('#aluminum-material-table tr').click(function (event) {
        var myClass = $(this).attr('class'),
            index = myClass.split(/wsMaterial_/)[1];
        $('#modal-material-selector-dialog').trigger( 'aluminum-material-selected', aluminumMaterialJson[index]);
        $(function () {
            $('#modal-material-selector-dialog').modal('toggle');
        });
    });
}

function initWoodTree() {
    var materials = woodVisual2to4MaterialJson;
    var str = '';
    var current_species = '';
    var data = [];
    var grades = [];
    onWoodMaterialSelected(materials[0]);
    for( var m in materials ) {
        var material = materials[m];
        if( current_species !== material['Species'] ) {
            // species has changed
            if( current_species !== '' ) {
                grades.sort(function(a, b) { return a.text > b.text })
                data.push({text: current_species, nodes: grades, state: {expanded: false}})
            }
            current_species = material['Species'];
            grades = [];
        }
        grades.push({text: material['Grade'], index: m})
    }

    $('#wood-material-tree').treeview({data: data});

    $('#wood-material-tree').on('nodeSelected', function(event, data) {
        if ('index' in data) {
            $('#modal-material-selector-dialog').trigger( 'wood-material-selected', woodVisual2to4MaterialJson[parseInt(data['index'])]);
            onWoodMaterialSelected(woodVisual2to4MaterialJson[parseInt(data['index'])]);
            $(function () {
                $('#modal-material-selector-dialog').modal('toggle');
            });
        }
    });
}

function onWoodMaterialSelected(woodMaterial) {
    var str = "<table class='table wood-material-box wood-material-table'><thead>";
    str += "<tr class='no-border'>";
    str += '<th>' + woodMaterial['Species'] + '</th><th>Fb</th><th>Ft</th><th>Fv</th><th>Fc</th><th>E</th>';
    str += '</thead></tr>';
    str += "<tr class='no-border'>";
    str += '<td>' + woodMaterial['Grade'] + '</td>';
    str += '<td>' + woodMaterial['Fb'] + '</td>';
    str += '<td>' + woodMaterial['Ft'] + '</td>';
    str += '<td>' + woodMaterial['Fv'] + '</td>';
    str += '<td>' + woodMaterial['Fc'] + '</td>';
    str += '<td>' + woodMaterial['E'] + '</td></tr>';
    str += '</table>';
    $('#wood-material-heading').html(str);
}
